import { getOrderProductsData } from '../helpers';
import { IUpdateOrderProductsDTO } from '@/models/orders.model';

class UpdateOrdersProductsDTO implements IUpdateOrderProductsDTO {
  order_id: string;
  products: {
    id: string;
    quantity: number;
  }[];
  add_new?: boolean;
  reason?: string;

  constructor({
    order_id,
    products,
    productToDelete,
    add_new,
    reason,
  }: {
    order_id: string;
    products: { [key: string]: number };
    productToDelete?: string;
    add_new?: boolean;
    reason?: string;
  }) {
    this.order_id = order_id;
    this.products = getOrderProductsData(products, productToDelete);
    this.add_new = add_new ?? false;
    this.reason = reason;
  }
}

export default UpdateOrdersProductsDTO;
